<section class="card">
  <p-table #dt [value]="onvoPayments" dataKey="onvoPaymentDataId" [paginator]="true" [rows]="10" [showCurrentPageReport]="true" [scrollable]="true" scrollHeight="150vh" currentPageReportTemplate="Mostrando {first} - {last} de {totalRecords}" [rowsPerPageOptions]="[10, 25, 50]" styleClass="p-datatable-gridlines" [tableStyle]="{ 'min-width': '40rem' }" [globalFilterFields]="['saleCode', 'status']">
    <ng-template #caption>
      <div class="flex items-center justify-between">
        <h2>Pagos Onvo</h2>
        <!-- <h5 class="m-0">Buscar Comercios</h5> -->
        <p-iconfield>
          <p-inputicon class="pi pi-search" />
          <input pInputText type="text" (input)="onInput($event)" placeholder="Busqueda Rápida" />
        </p-iconfield>
      </div>
    </ng-template>
    <ng-template #header>
      <tr>
        <th style="width: 5rem"></th>
        <th pSortableColumn="saleCode" style="width:20%">
          <div class="flex items-center gap-2">
            Código de Orden
            <p-sortIcon field="saleCode" />
          </div>
        </th>
        <th pSortableColumn="shopId" style="width:20%">
          <div class="flex items-center gap-2">
            Id de Pago
            <p-sortIcon field="shopId" />
          </div>
        </th>
        <th pSortableColumn="status" style="width:20%">
          <div class="flex items-center gap-2">
            Estado
            <p-sortIcon field="status" />
          </div>
        </th>
        <th pSortableColumn="shopSubscriptionName" style="width:20%">
          <div class="flex items-center gap-2">
            Mensaje
            <p-sortIcon field="shopSubscriptionName" />
          </div>
        </th>
        <th pSortableColumn="shopDomain" style="width:20%">
          <div class="flex items-center gap-2">
            Monto
            <p-sortIcon field="shopDomain" />
          </div>
        </th>
        <th></th>
      </tr>
      
    </ng-template>
    <ng-template #body let-payment let-expanded="expanded">
      <tr>
        <!-- <td><p-image [src]="store.image" alt="Image" width="100" />{{ store.shopName }}</td> -->
        <td><strong>{{ payment.shopName }}</strong></td>
        <td>{{ payment.shopId }}</td>
        <!-- <td><img [src]="store.shopImage" [alt]="store.shopName" width="50" class="shadow-lg" /></td> -->
        <td>{{ payment.shopSubscription }}</td>
        <td>{{ payment.shopDomain }}</td>
      </tr>
    </ng-template>
  </p-table>
</section>